import React from 'react';

function Footer() {
  const links = [
    { text: 'À propos', href: '#about' },
    { text: 'Contact', href: '#contact' },
    { text: 'FAQ', href: '#faq' },
    { text: 'Conditions', href: '#terms' },
    { text: 'Confidentialité', href: '#privacy' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-links">
          {links.map((link, index) => (
            <a key={index} href={link.href}>{link.text}</a>
          ))}
        </div>
        <p>&copy; 2026 Haivest. Tous droits réservés.</p>
        <p className="footer-info">
          Une plateforme d'investissement coopératif pour Haïti
        </p>
      </div>
    </footer>
  );
}

export default Footer;
